import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import { IoMdCall } from "react-icons/io";
import { FaEnvelope } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { RiInstagramFill } from "react-icons/ri";
import { FaFacebookSquare } from "react-icons/fa";
import "./contact.css";
import SEO from "../../Components/SEO";

const Contact = () => {

   const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // wait for DOM + iframe to render
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 300); // small delay is IMPORTANT
    }
  }, [location]);

  return (
    <div className="contactus-page-wrapper">
      <SEO
        title="BWC Sports | Contact"
        description=""
        url="https://bwcsports.com/contact-us"
      />
      <div className="contact-page">
        <div className="contact-header">
          <div className="cnct-back-btn">
            <BackBtn />
          </div>
          <div className="cnct-header-cnt">
            <h1 className="black-text-clip">Reach Us Directly</h1>
            <p className="black-text-clip">
              Whether you have a question about bookings, sessions, or special
              events, our team is here to help.
            </p>
          </div>
        </div>
        <div className="contact-body">
          <div className="contact-column cc-info">
            <div className="cc-info-cnt">
              <h2 className="black-text-clip">Get In Touch</h2>
              <div className="cc-card">
                <div className="cc-card-icon">
                  <span>
                    <FaEnvelope />
                  </span>
                </div>
                <div className="cc-card-cnt">
                  <h3>Email</h3>
                  <Link to="mailto:becausewecansports@gmail.com">
                    <span className="black-text-clip">
                      becausewecansports@gmail.com
                    </span>
                  </Link>
                </div>
              </div>

              <div className="cc-card">
                <div className="cc-card-icon">
                  <span>
                    <IoMdCall />
                  </span>
                </div>
                <div className="cc-card-cnt">
                  <h3>Phone</h3>
                  <Link to="tel:+13472120028">
                    <span className="black-text-clip">(347) 212-0028</span>
                  </Link>
                </div>
              </div>
            </div>
            <hr />

            <div className="cc-info-follow">
              <h3 className="black-text-clip">Follow Us On</h3>
              <div className="cc-follow-links">
                <Link
                  to="https://www.instagram.com/becausewecansports/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="cc-follow-icon">
                    {" "}
                    <RiInstagramFill />
                  </span>
                  Instagram
                </Link>
                <Link
                  to="https://www.facebook.com/becausewecansports"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="cc-follow-icon">
                    {" "}
                    <FaFacebookSquare />
                  </span>
                  Facebook
                </Link>
              </div>
            </div>
          </div>
          <div className="contact-column cc-bg-img"></div>
        </div>

        <div className="contact-2 contact-section" id="hl-contact-us">
          <div className="contact-section__header">
            <h1 className="contact-section__title">Contact Us</h1>
            <p className="black-text-clip">
              Request a quote or send us your query-we’ll get back to you as soon as possible.
            </p>
          </div>
          <div className="contact-section__form-wrapper">
            <iframe
              src="https://api.leadconnectorhq.com/widget/form/7qovKV4IaNdcjiVzsieJ"
              className="contact-section__form"
              title="Contact Form"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Contact;
